import React, { useState } from 'react';
import { oneOf } from 'prop-types';
import { MOBILE } from '@thd-olt-functional/utils';
import { HdppLearnmore } from '@thd-olt-component-react/hdpp-learnmore';
import { Info } from '@one-thd/sui-icons';
import { Button, Drawer, DrawerBody, DrawerHeader } from '@one-thd/sui-atomic-components';

const ProtectionPlanDrawer = ({
  channel
}) => {

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const isMobile = channel === MOBILE;
  const drawerMaxSize = isMobile ? 100 : 500;

  const openDrawer = (event) => {
    event.preventDefault();
    setIsDrawerOpen(true);
  };

  return (
    <div>
      <Button variant="text" className="sui-border-none" onClick={openDrawer}>
        <div className="sui-flex sui-space-x-1 sui-items-center">
          <span className="sui-text-base sui-underline sui-decoration-2
              sui-underline-offset-1 sui-decoration-transparent/30"
          >
            What to Expect
          </span>
          <div className="sui-mt-1">
            <Info size="small" color="primary" />
          </div>
        </div>
      </Button>
      {isDrawerOpen && (
        <Drawer
          open={isDrawerOpen}
          onClose={() => setIsDrawerOpen(false)}
          initialItem="Protection Plan View"
          position="right"
          maxSize={drawerMaxSize}
          isMobile={isMobile}
        >
          <DrawerHeader onClose={() => setIsDrawerOpen(false)}>
            <span className="sui-text-lg sui-font-black">Protect Your Purchase</span>
          </DrawerHeader>
          <DrawerBody name="Protection Plan View">
            <HdppLearnmore />
          </DrawerBody>
        </Drawer>
      )}
    </div>
  );
};

ProtectionPlanDrawer.displayName = 'ProductAddOns-HdppDrawer';

ProtectionPlanDrawer.propTypes = {
  /** Device Type: Mobile or Desktop */
  channel: oneOf(['desktop', 'mobile'])
};

ProtectionPlanDrawer.defaultProps = {
  channel: 'desktop'
};

export { ProtectionPlanDrawer };